/**
 * Front-end hover popover for offbeat/author-card.
 *
 * The card is position: fixed so no clipping or stacking ancestor (the dark hero
 * cover block that wraps the byline uses overflow: hidden) can trap it. On open,
 * its viewport coordinates are computed from the byline's rect and it is anchored
 * just below the byline, overhanging 20px to the left so the arrow lines up.
 * Hover-intent keeps it calm: a 120ms open delay and an 80ms close grace so the
 * pointer can travel from byline to card.
 */
document.addEventListener( 'DOMContentLoaded', function () {
	var blocks = document.querySelectorAll( '.offbeat-author-card' );

	blocks.forEach( function ( block ) {
		var byline = block.querySelector( '.offbeat-author-card__byline' );
		var card = block.querySelector( '.offbeat-author-card__wrapper' );

		if ( ! byline || ! card ) {
			return;
		}

		var openTimer = null;
		var closeTimer = null;

		function position() {
			var rect = byline.getBoundingClientRect();
			var bylineCenter = rect.left + rect.width / 2;
			var left = bylineCenter - card.offsetWidth / 2;
			var maxLeft = window.innerWidth - card.offsetWidth - 12;

			if ( left > maxLeft ) {
				left = maxLeft;
			}
			if ( left < 12 ) {
				left = 12;
			}

			card.style.top = ( rect.bottom + 14 ) + 'px';
			card.style.left = left + 'px';

			var arrowLeft = bylineCenter - left;
			var minArrow = 20;
			var maxArrow = card.offsetWidth - 20;

			if ( arrowLeft < minArrow ) {
				arrowLeft = minArrow;
			}
			if ( arrowLeft > maxArrow ) {
				arrowLeft = maxArrow;
			}

			card.style.setProperty( '--offbeat-author-card-arrow-left', arrowLeft + 'px' );
		}

		function open() {
			clearTimeout( closeTimer );
			clearTimeout( openTimer );
			openTimer = setTimeout( function () {
				position();
				card.classList.add( 'is-visible' );
				card.setAttribute( 'aria-hidden', 'false' );
			}, 120 );
		}

		function scheduleClose() {
			clearTimeout( openTimer );
			clearTimeout( closeTimer );
			closeTimer = setTimeout( function () {
				card.classList.remove( 'is-visible' );
				card.setAttribute( 'aria-hidden', 'true' );
			}, 80 );
		}

		byline.addEventListener( 'mouseenter', open );
		byline.addEventListener( 'focus', open );
		byline.addEventListener( 'mouseleave', scheduleClose );
		byline.addEventListener( 'blur', scheduleClose );

		card.addEventListener( 'mouseenter', function () {
			clearTimeout( closeTimer );
		} );
		card.addEventListener( 'mouseleave', scheduleClose );

		window.addEventListener(
			'scroll',
			function () {
				if ( card.classList.contains( 'is-visible' ) ) {
					position();
				}
			},
			true
		);
	} );
} );
